<template>
  <div class="static-page">
    <div class="card w-100" :class="backgroundClass">
      <div class="card-body d-flex align-items-center justify-content-center full-body-height my-5">
        <div class="col-lg-6 col-md-8 col-12 px-3">
          
          <!-- Header Image -->
          <div class="static-page-header mb-5 text-center">
            <img :src="headerImageUrl" :alt="page.title">
          </div>
          
          <!-- Title -->
          <h2 class="text-center fw-medium mb-4" v-html="page.title"></h2>
          
          <!-- Description -->
          <div v-if="page.description" class="my-4" v-html="page.description"></div>
          
          <!-- Features -->
          <div v-if="page.features && page.features != ''" class="page-features my-4">
            <div v-html="page.features"></div>
          </div>
          
          <!-- CTA Buttons -->
          <div class="mt-5 mb-3 text-center" v-if="page.cta && page.cta != '' || page.embed_url && page.embed_url != '' || showScheduleDemo">
            <div v-if="page.cta" v-html="page.cta"></div>
            <button 
              v-if="page.embed_url" 
              type="button" 
              class="btn btn-secondary ms-3"
              data-bs-toggle="modal" 
              data-bs-target="#videoModal">
              <img src="/img/icons/avid-icons/video.svg" alt="Video" class="icon">
              Watch Video
            </button>
            <button 
              v-if="showScheduleDemo" 
              type="button" 
              class="btn btn-primary ms-3"
              @click="openScheduleDemo">
              Schedule Demo
            </button>
          </div>
          
        </div>
      </div>
    </div>
    
    <!-- Video Modal -->
    <div v-if="page.embed_url" class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h5 class="modal-title" id="videoModalLabel">Video</h5>
            <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="tooltip" title="Close">
              <img class="icon me-0" src="/img/icons/avid-icons/close.svg" alt="">
            </button>
          </div>
          <div class="modal-body">
            <div class="ratio ratio-16x9" v-html="page.embed_url"></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Schedule Demo Modal -->
    <ScheduleDemoModal
      v-if="showScheduleDemo"
      ref="scheduleDemoModal"
      :user="user"
      :client="client"
      :instance-id="modalInstanceId"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import ScheduleDemoModal from './ScheduleDemoModal.vue';

export default defineComponent({
  name: 'StaticPage',
  
  components: {
    ScheduleDemoModal
  },
  
  props: {
    page: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: false,
      default: null
    },
    client: {
      type: Object,
      required: false,
      default: null
    },
    showScheduleDemo: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    backgroundClass() {
      return this.page.slug ? `${this.page.slug}-background` : 'playbooks-background';
    },
    
    headerImageUrl() {
      return this.page.slug 
        ? `/img/images/${this.page.slug}-static-heading.svg` 
        : '/img/images/playbooks-static-heading.svg';
    },
    
    demoUrl() {
      if (!this.user) {
        return 'https://www.avidai.com/demo/';
      }
      
      const params = new URLSearchParams({
        firstname: this.user.first_name || '',
        lastname: this.user.last_name || '',
        email: this.user.email || ''
      });
      
      return `https://www.avidai.com/demo/?${params.toString()}`;
    },
    
    modalInstanceId() {
      return this.page.slug ? `static-page-${this.page.slug}` : 'static-page-default';
    }
  },
  
  methods: {
    openScheduleDemo() {
      if (this.$refs.scheduleDemoModal) {
        this.$refs.scheduleDemoModal.openModal();
      }
    }
  }
});
</script>

<style scoped>
.page-features ul {
  list-style: none;
  position: relative;
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
}

.page-features ul li {
  position: relative;
  padding-left: 30px;
  margin-bottom: 10px;
  width: 50%;
}

.page-features ul li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 2px;
  width: 20px;
  height: 20px;
  background-image: url('/img/icons/avid-icons/check-01.svg');
  background-repeat: no-repeat;
  background-position: center;
  filter: invert(27%) sepia(85%) saturate(7494%) hue-rotate(357deg) brightness(99%) contrast(96%);
}

@media (max-width: 768px) {
  .page-features ul li {
    width: 100%;
  }
}

/* Modal responsive styling */
@media (max-width: 992px) {
  .modal-dialog.modal-xl {
    max-width: 90%;
  }
}
</style>

